import { Subscription } from "rxjs"
import { FormGroup, FormBuilder, FormControl } from "@angular/forms"
import { Component, OnInit, Input, ViewChild, ElementRef, Renderer, OnDestroy, SimpleChanges, Output, EventEmitter } from "@angular/core"
import {
  trigger,
  state,
  style,
  transition,
  animate
} from "@angular/animations"
import { InputSelectService } from "./input-select.service"
import { environment } from "../../../../environments/environment"
import { AppService } from "src/app/server/app.service";
export let isDebugMode = environment.isDebugMode

@Component({
  selector: "flow-input-select",
  templateUrl: "./input-select.component.html",
  styleUrls: ["./input-select.component.scss"],
  animations: [
    trigger("slideInOut", [
      state(
        "open",
        style({
          display: "block",
          opacity: 1
        })
      ),
      state(
        "close",
        style({
          display: "none",
          opacity: 0
        })
      ),
      transition("open => close", animate("100ms ease-in")),
      transition("close => open", animate("500ms ease-out"))
    ])
  ]
})
export class InputSelectComponent implements OnInit, OnDestroy {

  @ViewChild('inputSearch') inputSearch: ElementRef

  @Input() filter?: string
  @Input() selectId: number
  @Input() placeHolder: string
  @Input() label: string
  @Input() controlValue?: FormControl
  @Input() controlDescription?: FormControl
  @Input() disabled: boolean
  @Output() eventClear  = new EventEmitter();
  @Output() eventChange = new EventEmitter();

  myjson: any = JSON;
  subscriptions: Array<Subscription> = []
  selectForm: FormGroup

  dropdownOpen: boolean = false
  menuState: string = "close"
  message: string = "Carregando..."
  filteredBy: string
  selectedItem = <any>[]
  items = []
  themeid: number = 1
  value: string
  description: string


  constructor(
    private appService: AppService,
    private renderer: Renderer,
    private selectService: InputSelectService,
    private fb: FormBuilder
  ) { }

  /*
    
  export const getControlName = (control: ng.forms.AbstractControl) =>
  {
      var controlName = null;
      var parent = control["_parent"];
  
      // only such parent, which is FormGroup, has a dictionary 
      // with control-names as a key and a form-control as a value
      if (parent instanceof ng.forms.FormGroup)
      {
          // now we will iterate those keys (i.e. names of controls)
          Object.keys(parent.controls).forEach((name) =>
          {
              // and compare the passed control and 
              // a child control of a parent - with provided name (we iterate them all)
              if (control === parent.controls[name])
              {
                  // both are same: control passed to Validator
                  //  and this child - are the same references
                  controlName = name;
              }
          });
      }
      // we either found a name or simply return null
      return controlName;
  }
  
  */

  ngOnInit() {
    isDebugMode ? console.info('ngOnInit()') : undefined

    this.subscriptions.push(

      this.controlValue.valueChanges.subscribe(val => {
        this.selectForm.patchValue({ value: val })
      }),
      this.controlDescription.valueChanges.subscribe(val => {
        this.selectForm.patchValue({ description: val })
      }),
      this.appService.eventClick.subscribe(event => {
        //console.log('eventClick', event)
        this.onExit(event)
      }),
      this.appService.eventSession.subscribe(session => {
        this.themeid = session.themeid
      })

    )

    this.initForms()
  }

  ngOnDestroy() {
    isDebugMode ? console.info('ngOnDestroy()') : undefined
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }

  ngOnChanges(changes: SimpleChanges) {

    // if (changes.filter) {
    //   if (this.selectForm) {
    //     Object.keys(changes.filter.previousValue).forEach(key => {
    //       //console.log(key, changes.filter.previousValue[key], changes.filter.previousValue[key] != "")
    //       if (changes.filter.previousValue[key]) {
    //         if (changes.filter.previousValue[key] != "") {
    //           this.clearSelect()
    //           this.getData()
    //         }
    //       }
    //     })
    //   }
    // }

  }

  initForms() {
    isDebugMode ? console.info('initForms()') : undefined
    this.selectForm = this.fb.group({
      value: this.fb.control(""),
      description: this.fb.control({ value: '', disabled: false }),
      subdescr: this.fb.control({ value: '', disabled: true }),
      disable: this.fb.control("0"),
      search: this.fb.control("")
    })
  }

  itemSelect(event) {
    isDebugMode ? console.info('itemSelect()') : undefined
    this.dropdownOpen = false // !this.dropdownOpen
    this.menuState = this.dropdownOpen ? "open" : "close"

    console.log(event)

    if (event.disable == 0) {
      this.selectForm.patchValue(event)

      let parent = this.controlValue["_parent"];
      Object.keys(parent.controls).forEach(
        (name) => {
          if (this.controlValue === parent.controls[name]) {
            this.value = name
          }
          if (this.controlDescription === parent.controls[name]) {
            this.description = name
          }
        }
      )

    //   console.log(`{
    //     "${this.value}":"${this.selectForm.controls['value'].value}"
    //    ,"${this.description}":"${this.selectForm.controls['description'].value}"
    // }`)


      this.eventChange.emit(
        JSON.parse
          (
            `{
            "${this.value}":"${this.selectForm.controls['value'].value}"
           ,"${this.description}":"${this.selectForm.controls['description'].value}"
        }`
          )
      )

    }
  }

  clearSelect() {
    isDebugMode ? console.info('clearSelect()') : undefined

    if (!this.disabled) {
      this.controlValue.reset()
      this.controlDescription.reset()
      this.selectForm.reset()
    }

    this.eventClear.emit(
      JSON.parse
        (
          `{
          "${this.value}":"${this.selectForm.controls['value'].value}"
         ,"${this.description}":"${this.selectForm.controls['description'].value}"
        }`
        )
    )

  }

  selectInput(event) {
    isDebugMode ? console.info('selectInput()') : undefined
    event.target.select()
  }

  loadItem(value: string) {

    if (this.items.length === 0 || this.filter !== this.filteredBy) {
      this.filteredBy = this.filter
      this.getData()
    }

    setTimeout(() => {
      if (value) {
        this.selectedItem = this.items.find(x => x.value === value)
        if (this.selectedItem) {
          if (this.selectedItem.disable === "0") {
            this.selectForm.patchValue(this.selectedItem)
          } else {
            this.selectForm.reset()
          }
        } else {
          //console.log("Código não encontrado")

          // $('#ModalSelectMessage')
          //   .on('shown.bs.modal', () => {
          //     this.messageModal = "Código não encontrado"
          //   })
          //   .on('hidden.bs.modal', (e) => {
          //     this.messageModal = ""
          //     this.selectForm.patchValue({
          //       value: "",
          //       description: "",
          //       disable: "",
          //       search: ""
          //     })
          //   })
          //   .modal({
          //     show: true
          //   })
        }
      } else {
        this.selectForm.patchValue({
          value: "",
          description: "",
          disable: "",
          search: ""
        })
      }
    }, 200)
  }

  onBlur(event) {
    this.loadItem(event.target.value)
  }

  click(event){
    console.log("click", event.target.getAttribute("data-cmd"))
  }
  onOpened(event) {
    //console.log("onOpened", event.target.getAttribute("data-cmd"))

    if (!this.disabled) {

      if (event.target.getAttribute("data-cmd") == 0) {
        this.dropdownOpen = !this.dropdownOpen
        this.menuState = this.dropdownOpen ? "open" : "close"
        if (this.items.length === 0 || this.filter !== this.filteredBy) {
          this.filteredBy = this.filter
          this.getData()
        }
      }

      if (event.target.getAttribute("data-cmd") == 4) {
        this.selectForm.reset()
        this.getData()
      }

      setTimeout(() => {
        this.renderer.invokeElementMethod(this.inputSearch.nativeElement, 'focus') // NEW VERSION
      }, 100)
    }

  }

  getData() {
    try {
      this.selectService.selectid = this.selectId
      this.selectService.getData(this.filter).subscribe(
        data => {
          this.items = data.recordsets[1]
        },
        res => {
          console.log(res.error)
          this.message = "Erro na requisição, não foi possível selecionar os registros"
        }
      )

    } catch (error) {
      console.log(error)
      this.message = "Erro na requisição, não foi possível selecionar os registros"
    }
  }

  onExit(event) {
    //console.log(event)
    this.dropdownOpen = false
    this.menuState = this.dropdownOpen ? "open" : "close"
  }
}

